import { create } from "zustand";
import { persist } from "zustand/middleware";

export type GridChartIdmMode = "net" | "split";

interface GridChartState {
  visible: boolean;
  idmMode: GridChartIdmMode;
  showBm: boolean;
  toggleVisible(): void;
  setIdmMode(mode: GridChartIdmMode): void;
  toggleBm(): void;
}

export const useGridChart = create<GridChartState>()(
  persist(
    (set) => ({
      visible: true,
      idmMode: "net",
      showBm: true,
      toggleVisible: () => set((s) => ({ visible: !s.visible })),
      setIdmMode: (idmMode) => set({ idmMode }),
      toggleBm: () => set((s) => ({ showBm: !s.showBm })),
    }),
    {
      name: "chro-grid-chart-v1",
    }
  )
);
